import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Tabs,
  Card,
  Row,
  Col,
  Select,
  Input,
  DatePicker,
  Checkbox,
  InputNumber,
  Radio,
} from "antd";

import dayjs from "dayjs";
import { GestionPaieService } from "../../Services/GestionPaieService";
const { Option } = Select;
const { TabPane } = Tabs;

const SalariesModal = ({
  isVisible,
  onClose,
  employee,
  categories,
  convention,
  onSuccess
}) => {
  const [form] = Form.useForm();
  const [paymentMode, setPaymentMode] = useState("V");
  const [nom, setNom] = useState("");
  const [prenoms, setPrenoms] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null); // Nouvel état pour la catégorie sélectionnée

  const gestionPaiesService = new GestionPaieService();

  useEffect(() => {
    if (employee) {
      setNom(employee.nom);
      setPrenoms(employee.prenoms);
      const fieldsValue = {
        ...employee,
        nom: employee.nom,
        prenoms: employee.prenoms,
        titulaire: formatTitulaire(employee.prenoms, employee.nom),
        datenaiss: employee.datenaiss ? dayjs(employee.datenaiss) : null,
        datemb: employee.datemb ? dayjs(employee.datemb) : null,
        datedeb: employee.datedeb ? dayjs(employee.datedeb) : null,
        datefin: employee.datefin ? dayjs(employee.datefin) : null,
      };
      form.setFieldsValue(fieldsValue);
    } else {
      form.resetFields();
    }
  }, [employee, form]);




  const formatTitulaire = (nom, prenoms) => {
    // Enlevez les espaces excessifs et ne concaténez pas si les valeurs sont vides
    const trimmedNom = nom?.trim();
    const trimmedPrenoms = prenoms?.trim();
    return [trimmedNom, trimmedPrenoms].filter(Boolean).join(" ");
  };

  useEffect(() => {
    form.setFieldsValue({
      titulaire: formatTitulaire(prenoms, nom),
    });
  }, [nom, prenoms, form]);

  useEffect(() => {
    if (paymentMode === "E") {
      // Reset les champs du RIB si le mode de paiement est 'Espèce'
      form.setFieldsValue({
        codebque: null,
        codeguichet: null,
        numcpte: null,
        cle: null,
        titulaire: null,
        nombque: null,
      });
    }
  }, [paymentMode, form]);

  const onPaymentModeChange = (e) => {
    const mode = e.target.value;
    setPaymentMode(mode);
  };
  const isRIBDisabled = paymentMode === "E";

  const civiliteOptions = {
    Mr: { code: "Mr", label: "Monsieur" },
    Mme: { code: "Mme", label: "Madame" },
    Mlle: { code: "Mlle", label: "Mademoiselle" },
  };

  const natcontOptions = {
    CDI: { code: "CDI", label: "Contrat à Durée Indéterminée" },
    CDD: { code: "CDD", label: "Contrat à Durée Déterminée" },
    STAGE: { code: "STAGE", label: "Stage" },
  };

  const sitfamOptions = {
    C: { code: "C", label: "Célibataire" },
    M: { code: "M", label: "Marié(e)" },
    D: { code: "D", label: "Divorcé(e)" },
    V: { code: "V", label: "Veuf(ve)" },
  };

  /*  const handleSave = async () => {
     let formData = form.getFieldsValue();
   
     // Fonction pour formater la date en chaîne ISO avec heure à minuit
     const formatDateToISOString = (date) => {
       return date ? dayjs(date).startOf('day').toISOString() : "";
     };
   
     const payload = {
      
       adresse: formData.adresse,
       civilite: formData.civilite,
       categ: formData.categ,
       cle: formData.cle,
       codebque: formData.codebque,
       codeguichet: formData.codeguichet,
       codepostal: formData.codepostal,
       complement: formData.complement,
       convention: formData.convention,
       datedeb: formatDateToISOString(formData.datedeb),
       datefin: formatDateToISOString(formData.datefin),
       datemb: formatDateToISOString(formData.datemb),
       datenaiss: formatDateToISOString(formData.datenaiss),
       emploi: formData.emploi,
       ipres: formData.ipres,
       lieunaiss: formData.lieunaiss,
       matricule: formData.matricule,
       modepaie: formData.modepaie,
       natcont: formData.natcont,
       nationalite: formData.nationalite || "SENEGALAISE",
       nbenf: formData.nbenf || 0,
       nbep: formData.nbep || 0,
       nbpart: formData.nbpart || 0,
       nom: formData.nom,
       nombque: formData.nombque,
       numcpte: formData.numcpte,
       numss: formData.numss,
       pays: formData.pays || "SENEGAL",
       prenoms: formData.prenoms,
       sitfam: formData.sitfam,
       sommeil: formData.sommeil || false,
       statut: formData.statut,
       titulaire: formData.titulaire,
       trimf: formData.trimf || 0,
       txhoraire: formData.txhoraire,
       txsursal: formData.txsursal || null,
       ville: formData.ville,
       
       perim: "IPM",
       _categ: categories.find(categ => categ.codecateg === formData.categ) || [],
       _convention: convention.find(conv => conv.codeconv === formData.convention) || [],
       _civilite: civiliteOptions[formData.civilite] || {
         code: formData.civilite,
         label: "",
       },
       _natcont: natcontOptions[formData.natcont] || {
         code: formData.natcont,
         label: "",
       },
       _sitfam: sitfamOptions[formData.sitfam] || {
         code: formData.sitfam,
         label: "",
       },
     };
   
     try {
       let response;
       if (employee && employee.matricule) {
         // Update employee
         response = await gestionPaiesService.upDataSalaries(payload);
       } else {
         // Add new employee
         response = await gestionPaiesService.addSalaries(payload);
       }
       console.log("Enregistrement réussi", response);
       onSuccess();
     } catch (error) {
       console.error("Erreur lors de l'enregistrement :", error);
       // Afficher un message d'erreur à l'utilisateur
       Modal.error({
         title: 'Erreur',
         content: 'Une erreur s\'est produite lors de l\'enregistrement des données. Veuillez réessayer.',
       });
     }
   }; */

  const handleSave = async () => {
    let formData = form.getFieldsValue();

    const formatDateToISOString = (date) => {
      return date ? dayjs(date).startOf('day').toISOString() : "";
    };

    const payload = {
      ...employee, // Inclure toutes les données de l'enregistrement ici
      adresse: formData.adresse,
      civilite: formData.civilite,
      categ: formData.categ,
      cle: formData.cle,
      codebque: formData.codebque,
      codeguichet: formData.codeguichet,
      codepostal: formData.codepostal,
      complement: formData.complement,
      convention: formData.convention,
      datedeb: formatDateToISOString(formData.datedeb),
      datefin: formatDateToISOString(formData.datefin),
      datemb: formatDateToISOString(formData.datemb),
      datenaiss: formatDateToISOString(formData.datenaiss),
      emploi: formData.emploi,
      ipres: formData.ipres,
      lieunaiss: formData.lieunaiss,
      matricule: formData.matricule,
      modepaie: formData.modepaie,
      natcont: formData.natcont,
      nationalite: formData.nationalite || "SENEGALAISE",
      nbenf: formData.nbenf || 0,
      nbep: formData.nbep || 0,
      nbpart: formData.nbpart || 1,
      nom: formData.nom,
      nombque: formData.nombque,
      numcpte: formData.numcpte,
      numss: formData.numss,
      pays: formData.pays || "SENEGAL",
      prenoms: formData.prenoms,
      sitfam: formData.sitfam,
      sommeil: formData.sommeil || false,
      statut: formData.statut,
      titulaire: formData.titulaire,
      trimf: formData.trimf || 1,
      txhoraire: formData.txhoraire,
      txsursal: formData.txsursal || 0,
      ville: formData.ville,

      perim: "IPM",
      /*   _categ: categories.find(categ => categ.codecateg === formData.categ) || [],
        _convention: convention.find(conv => conv.codeconv === formData.convention) || [],
        _civilite: civiliteOptions[formData.civilite] || {
          code: formData.civilite,
          label: "",
        },
        _natcont: natcontOptions[formData.natcont] || {
          code: formData.natcont,
          label: "",
        },
        _sitfam: sitfamOptions[formData.sitfam] || {
          code: formData.sitfam,
          label: "",
        }, */
    };

    try {
      let response;
      if (employee && employee.matricule) {
        response = await gestionPaiesService.upDataSalaries(payload);
      } else {
        response = await gestionPaiesService.addSalaries(payload);
      }
      onSuccess();
    } catch (error) {
      Modal.error({
        title: 'Erreur',
        content: 'Une erreur s\'est produite lors de l\'enregistrement des données. Veuillez réessayer.',
      });
    }
  };

  return (
    <Modal
      maskClosable={false}
      title={
        employee && Object.keys(employee).length > 0
          ? "Modification Salarié"
          : "Nouveau Salarié"
      }
      open={isVisible}
      onOk={handleSave}
      onCancel={onClose}
      width={1000}
      style={{ top: 20 }}
    >
      <Form layout="vertical" form={form}>
        <Tabs defaultActiveKey="1">
          <TabPane tab="État Civil" key="1">
            <Card title="État Civil" size="small" bordered={false}>
              <Row gutter={8}>
                <Col span={4}>
                  <Form.Item
                    label="Matricule"
                    name="matricule"
                    rules={[{ required: true }]}
                  >
                    <Input style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item
                    label="Civilité"
                    name="civilite"
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder="Sélectionner"
                      style={{ width: "100%" }}
                    >
                      <Select.Option value="Mr">Mr</Select.Option>
                      <Select.Option value="Mme">Mme</Select.Option>
                      <Select.Option value="Mlle">Mlle</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="Nom" name="nom">
                    <Input onChange={(e) => setNom(e.target.value)} />
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item label="Prénom(s)" name="prenoms">
                    <Input onChange={(e) => setPrenoms(e.target.value)} />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={8}>
                  <Form.Item label="Sit. Familiale" name="sitfam">
                    <Select
                      placeholder="- Sélectionner -"
                      style={{ width: "100%" }}
                    >
                      <Select.Option value="C">Célibataire</Select.Option>
                      <Select.Option value="M">Marié</Select.Option>
                      <Select.Option value="D">Divorcé(e)</Select.Option>
                      <Select.Option value="V">Veuf(ve)</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Nb. d'Enfants" name="nbenf">
                    <InputNumber style={{ width: "100%" }} min={0} />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Nb. de Femmes" name="nbep">
                    <InputNumber style={{ width: "100%" }} min={0} />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
            <Card title="Immatriculation" size="small" bordered={false}>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    label="Date de Naissance"
                    name="datenaiss"
                    rules={[{ required: true }]}
                  >
                    <DatePicker format="DD/MM/YYYY" disabledDate={(current) => current && current > dayjs().endOf('day')} />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Lieu de Naissance"
                    name="lieunaiss"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Nationalité"
                    name="nationalite"
                    rules={[{ required: true }]}
                    initialValue="SENEGALAISE"
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="N° Sécurité Sociale"
                    name="numss"
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="N° IPRES" name="ipres">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </TabPane>
          <TabPane tab="Coordonnées" key="2">
            <Card title="Adresse" size="small" bordered={false}>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    label="Adresse"
                    name="adresse"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={16}>
                  <Form.Item label="Complément" name="complement">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item label="Code Postal" name="codepostal">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Ville"
                    name="ville"
                    rules={[{ required: true }]}
                    initialValue="DAKAR"
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Pays"
                    name="pays"
                    rules={[{ required: true }]}
                    initialValue="SENEGAL"
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
            <Row gutter={16}>
              <Col span={16}>
                <Card title="RIB" size="small" bordered={false}>
                  <Row gutter={16}>
                    <Col span={6}>
                      <Form.Item
                        label="Code Banque"
                        name="codebque"
                        rules={[
                          { required: !isRIBDisabled },
                          {
                            pattern: /^[A-Za-z]{2}\d{5}$/,
                            message:
                              "Doit contenir 2 lettres suivies de 5 chiffres",
                          },
                        ]}
                      >
                        <Input disabled={isRIBDisabled} />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        label="Code Guichet"
                        name="codeguichet"
                        rules={[
                          { required: !isRIBDisabled },
                          {
                            pattern: /^\d{6}$/,
                            message: "Doit contenir 6 chiffres",
                          },
                        ]}
                      >
                        <Input disabled={isRIBDisabled} />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        label="N° du Compte"
                        name="numcpte"
                        rules={[
                          { required: !isRIBDisabled },
                          {
                            pattern: /^\d{10}$/,
                            message: "Doit contenir 10 chiffres",
                          },
                        ]}
                      >
                        <Input disabled={isRIBDisabled} />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        label="Clé"
                        name="cle"
                        rules={[
                          { required: !isRIBDisabled },
                          {
                            pattern: /^\d{2}$/,
                            message: "Doit contenir 2 chiffres",
                          },
                        ]}
                      >
                        <Input disabled={isRIBDisabled} />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        label="Titulaire du Compte"
                        name="titulaire"
                        rules={[{ required: !isRIBDisabled }]}
                      >
                        <Input readOnly disabled={isRIBDisabled} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Nom de la Banque"
                        name="nombque"
                        rules={[{ required: !isRIBDisabled }]}
                      >
                        <Input disabled={isRIBDisabled} />
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col span={8}>
                <Card title="Mode de Paiement" size="small" bordered={false}>
                  <Form.Item name="modepaie" initialValue="V">
                    <Radio.Group
                      onChange={onPaymentModeChange}

                    >
                      <Radio
                        style={{
                          display: "block",
                          height: "30px",
                          lineHeight: "30px",
                        }}
                        value="V"
                      >
                        Virement
                      </Radio>
                      <Radio
                        style={{
                          display: "block",
                          height: "30px",
                          lineHeight: "30px",
                        }}
                        value="C"
                      >
                        Chèque
                      </Radio>
                      <Radio
                        style={{
                          display: "block",
                          height: "30px",
                          lineHeight: "30px",
                        }}
                        value="E"
                      >
                        Espèce
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                </Card>
              </Col>
            </Row>
          </TabPane>

          <TabPane tab="Contrat" key="3">
            <Form.Item
              label="Mise en Sommeil"
              name="sommeil"
              valuePropName="checked"
            >
              <Checkbox />
            </Form.Item>
            <Card title="Contrat de Travail" size="small" bordered={false}>
              <Row gutter={16}>
                <Col>
                  <Form.Item
                    label="Date d'Embauche"
                    name="datemb"
                    rules={[{ required: true }]}
                  >
                    <DatePicker
                      format="DD/MM/YYYY"
                      disabledDate={(current) => current && current > dayjs().endOf('day')}
                    />
                    name="natcont"
                    rules={[{ required: true }]}
                  >
                    <Select placeholder="Sélectionner">
                      <Select.Option value="CDI">Contrat à Durée Indéterminée</Select.Option>
                      <Select.Option value="CDD">Contrat à Durée Déterminée</Select.Option>
                      <Select.Option value="STAGE">Stage</Select.Option>
                    </Select>

                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    label="Date de Début"
                    name="datedeb"
                    rules={[{ required: true }]}
                  >
                    <DatePicker
                      format="DD/MM/YYYY"
                      disabledDate={(current) => current && current > dayjs().endOf('day')}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item label="Date de Fin" name="datefin">
                    <DatePicker
                      format="DD/MM/YYYY"
                      disabledDate={(current) => current && current > dayjs().endOf('day')}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Convention Collective"
                    name="convention"
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder="Sélectionner"
                      showSearch
                      optionFilterProp="children"

                    >
                      {convention.map((conv) => (
                        <Option
                          key={conv.codeconv}
                          value={conv.codeconv}

                        >
                          {conv.libconv}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label="Emploi"
                    name="emploi"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Statut"
                    name="statut"
                    rules={[{ required: true }]}
                  >
                    <Select placeholder="Select">
                      <Select.Option value="cadre">Cadre</Select.Option>
                      <Select.Option value="employe">Employe</Select.Option>
                      <Select.Option value="matrise">Maitrise</Select.Option>
                      <Select.Option value="ouvrier">Ouvrier</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Card>
            <Card title="Paie" size="small" bordered={false}></Card>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  label="Catégorie"
                  name="categ"
                  rules={[{ required: true }]}
                >
                  <Select
                    placeholder="Sélectionner"
                    showSearch
                    onChange={(value) => {
                      const category = categories.find(categ => categ.codecateg === value);
                      setSelectedCategory(category);
                      form.setFieldsValue({ txhoraire: category.valcateg });
                    }}
                  >
                    {categories.map((categ) => (
                      <Option key={categ.codecateg} value={categ.codecateg}>
                        {categ.libelle}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

              </Col>
              <Col span={8}>
                <Form.Item
                  label="Salaire de Base(Tx Hor./Mens)"
                  name="txhoraire"
                  rules={[{ required: true }]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>

              </Col>
              <Col span={8}>
                <Form.Item
                  label="Sursalaire"
                  name="txsursal"
                  rules={[{ required: true }]}

                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  label="Nombre de Part"
                  name="nbpart"
                  rules={[{ required: true }]}
                  initialValue="1"
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="TRIMF"
                  name="trimf"
                  rules={[{ required: true }]}
                  initialValue="1"
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>
          </TabPane>
        </Tabs>
      </Form>
    </Modal>
  );
};

export default SalariesModal;
